import React, { FC, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { IRoute } from 'models';
import strings from 'tools';
import { Checkbox } from 'antd';
import { Button, EmptySearch, ErrorRequest, Header, Icons, Layout } from 'components/layout';
import offerStore from 'store/OffersStore';
import { OffersTable } from 'components/offer';

import './offers.scss';

interface Props {
    navigation: IRoute[];
}

const Offers: FC<Props> = observer((props: Props) => {
    const { navigation } = props;
    const [isAddOffer, setIsAddOffer] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const { offers, isLoading } = offerStore;
    const [showActive, setShowActive] = useState(true);
    const [showInactive, setShowInactive] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        offerStore.getOffers();
    }, []);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    useEffect(() => {
        if (isAddOffer) {
            navigate('/offers/new');
        }
    }, [isAddOffer]);

    const onTurnOffOffer = (id: string) => {
        offerStore.turnOffOffer(id);
    };

    const onTurnOnOffer = (id: string) => {
        offerStore.turnOnOffer(id);
    };

    const handleActiveChange = (checked: boolean) => {
        if (!checked && !showInactive) return;
        setShowActive(checked);
    };

    const handleInactiveChange = (checked: boolean) => {
        if (!checked && !showActive) return;
        setShowInactive(checked);
    };

    const filteredOffers = offers?.filter((offer) => {
        if (showActive && showInactive) return true;

        if (showActive) return offer.available === true;
        if (showInactive) return offer.available === false;

        return false;
    });

    return (
        <Layout page="offers" navigation={navigation} errorScreen>
            <Header
                title="Тарифы"
                description={
                    offers
                        ? `Всего ${offers.length} ${strings.ending(offers.length, [
                              'тариф',
                              'тарифа',
                              'тарифов',
                          ])}`
                        : ''
                }
            />
            <div className="page-offers">
                <div className="offers-top">
                    <Button onClick={() => setIsAddOffer(true)} type="primary">
                        {Icons.plus()} Создать
                    </Button>
                    <Checkbox
                        checked={showActive}
                        onChange={(e) => handleActiveChange(e.target.checked)}
                        style={{ marginLeft: 16 }}
                    >
                        Показать только активные
                    </Checkbox>

                    <Checkbox
                        checked={showInactive}
                        onChange={(e) => handleInactiveChange(e.target.checked)}
                        style={{ marginLeft: 12 }}
                    >
                        Показать только неактивные
                    </Checkbox>
                </div>
                {offers?.length && (offers?.length > 0 || isLoading) && (
                    <OffersTable
                        data={filteredOffers || []}
                        loading={isLoading}
                        onTurnOffOffer={onTurnOffOffer}
                        onTurnOnOffer={onTurnOnOffer}
                    />
                )}
                {!offers?.length && !isLoading && <EmptySearch />}
                {!offers && <ErrorRequest onClick={() => offerStore.getOffers()} />}
            </div>
        </Layout>
    );
});

export default Offers;
